'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var _PublishNewHomesForm2 = _interopRequireDefault(_PublishNewHomesForm);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CommodityCard = function CommodityCard(_ref) {var content = _ref.content,onClick = _ref.onClick;
  var handleClick = function handleClick() {return onClick(content);};

  return (
    _react2.default.createElement('button', {
        type: 'button',
        className: _PublishNewHomesForm2.default.commodityCard,
        onClick: handleClick },

      _react2.default.createElement('span', { className: _PublishNewHomesForm2.default.commodityCardText }, content),
      _react2.default.createElement('span', { className: _PublishNewHomesForm2.default.minus }, '-')));


};exports.default =

CommodityCard;

CommodityCard.propTypes = {
  content: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/CommodityCard.js
// module id = 3031
// module chunks = 0